// These are custom user attributes we support within Braze:
export enum BrazeCustomAttributes {
  VISIBLE_IN_TALENT_SCOUT = 'visible_in_talent_scout',
}
